import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { listAdmin, modifyAdmin, deleteAdmin, findAdmin, updateAdmin, registerAdmin, logoutAdmin } from '../_actions/user_action';
import '../css_admin/Header.css';
import '../css_admin/Body.css';

import Button from '@mui/material/Button';

/* Radio Group */
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import { getAdminAccount, clearSession } from '../utils/session';

// import Checkbox from '@mui/material/Checkbox';

// const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

function AdminSetting() {
    const dispatch = useDispatch();

    const adminAccount = getAdminAccount() || {};

    const onLogoutHandler = async (event) => {
        event.preventDefault();

        let body = { email: adminAccount.email };
        await dispatch(logoutAdmin(body));

        clearSession();
        window.location.replace('/');
    };

    // <!--
    // Start - 관리자 리스트  Administrator List
    const [adminListInfo, setAdminListInfo] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(-1);

    useEffect(() => {
        dispatch(listAdmin())
        .then(response => {
            // console.log(response);

            if (response.payload.listSuccess) {
                setAdminListInfo(response.payload.adminList);
                setSelectedIndex(-1);
            }
        })
        .catch((err) => console.log(err));
    }, []);

    const handleChangeListSelect = (e) => {
        e.preventDefault();

        let targetIndex = e.target.value;
        if (targetIndex < 0)
            return;

        setSelectedIndex(targetIndex);
        // console.log(adminListInfo[targetIndex]);

        setInputsModify({
            ...inputsModify,
            modifyName: adminListInfo[targetIndex].name,
            modifyEmail: adminListInfo[targetIndex].email,
            modifyPassword: "",
            modifyPasswordConfirm: "",
            modifyGrade: adminListInfo[targetIndex].grade
        });
    };
    // End - 관리자 리스트 Administrator List
    // -->

    // <!--
    // Start - 관리자 정보수정  Modify Administrator Information
    const focusRefModifyName = useRef();
    const focusRefModifyPassword = useRef();
    const focusRefModifyPasswordConfirm = useRef();

    const [inputsModify, setInputsModify] = useState({
        modifyName: "",
        modifyEmail: "",
        modifyPassword: "",
        modifyPasswordConfirm: "",
        modifyGrade: ""
    });

    const { modifyName, modifyEmail, modifyPassword, modifyPasswordConfirm, modifyGrade } = inputsModify;

    const handleChangeModify = (e) => {
        const { value, name } = e.target;
        setInputsModify({
            ...inputsModify,
            [name]: value
        });
    };

    const handleSubmitModify = (e) => {
        e.preventDefault();

        if (selectedIndex < 0)
            return;
        
        let modify_key = "";
        let modify_errors = "";

        const selectAdmin = {
            name: modifyName,
            email: modifyEmail,
            password: modifyPassword,
            passwordConfirm: modifyPasswordConfirm,
            grade: modifyGrade
        };

        for (var key in selectAdmin) {
            modify_errors = "";

            if (selectAdmin[key].length === 0 || selectAdmin[key] === undefined) {
                modify_key = key;

                if (key === 'name') {
                    modify_errors = "[관리자명]이 없습니다.";
                } else if (key === 'email') {
                    modify_errors = "[아이디]가 없습니다.";
                } else if (key === 'password') {
                    modify_errors = "[비밀번호]가 없습니다.";
                } else if (key === 'passwordConfirm') {
                    modify_errors = "[비밀번호 확인]이 없습니다."
                } else if (key === 'grade') {
                    modify_errors = "[관리등급]을 선택해주세요.";
                }
            }

            if (modify_errors.length > 1)
                break;
        }

        if (modify_errors.length > 1) {
            alert(modify_errors);

            if (modify_key === 'name') {
                focusRefModifyName.current.focus();
            } else if (modify_key === 'email') {
                //
            } else if (modify_key === 'password') {
                focusRefModifyPassword.current.focus();
            } else if (modify_key === 'passwordConfirm') {
                focusRefModifyPasswordConfirm.current.focus();
            }

            return;
        }

        if (modifyName.length < 2 || modifyName.length > 30) {
            modify_errors = "2글자 이상 30글자 미만으로 입력해주세요.";
            alert(modify_errors);
            focusRefModifyName.current.focus();
            return;
        }

        const passwordRegex =
        // /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+])(?!.*[^a-zA-z0-9$`~!@$!%*#^?&\\(\\)\-_=+]).{8,20}$/;
        /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,25}$/;
        if (!passwordRegex.test(modifyPassword)) {
            modify_errors = "영문, 숫자, 특수문자 포함 8자 이상 입력해주세요.";
            alert(modify_errors);
            focusRefModifyPassword.current.focus();
            return;
        }

        if (modifyPassword !== modifyPasswordConfirm) {
            modify_errors = "비밀번호가 틀려요. 다시 확인해주세요.";
            alert(modify_errors);
            setInputsModify({
                ...inputsModify,
                modifyPasswordConfirm: ""
            });
            focusRefModifyPasswordConfirm.current.focus();
            return;
        }
  
        let body = {
            email: modifyEmail,
            password: modifyPassword,
            name: modifyName,
            grade: modifyGrade
        }
        // console.log(body);

        let modify_msg = "";

        dispatch(modifyAdmin(body))
        .then(response => {
            console.log(response);

            if (response.payload.modifySuccess) {
                modify_msg = "[" + body.email + " (" + body.name + ")] 관리자 정보수정 되었습니다.";
                alert(modify_msg);
                window.location.replace('/AdminSetting');
            } else {
                alert(response);
            }
        }).catch((err) => console.log(err));
    };

    const [showModifyPassword, setShowModifyPassword] = useState(false);
    const handleClickShowModifyPassword = () => setShowModifyPassword((show) => !show);
    const handleMouseDownModifyPassword = (event) => {
      event.preventDefault();
    }

    const [showModifyPasswordConfirm, setShowModifyPasswordConfirm] = useState(false);
    const handleClickShowModifyPasswordConfirm = () => setShowModifyPasswordConfirm((show) => !show);
    const handleMouseDownModifyPasswordConfirm = (event) => {
      event.preventDefault();
    }
    // End - 관리자 정보수정  Modify Administrator Information

    // Start - 관리자 정보수정  Modify Administrator Information [삭제]
    const handleSubmitDelete = (e) => {
        e.preventDefault();
        
        if (selectedIndex < 0)
            return;
        
        let delete_key = "";
        let delete_errors = "";

        const selectAdmin = {
            name: modifyName,
            email: modifyEmail,
            password: modifyPassword,
            passwordConfirm: modifyPasswordConfirm,
            grade: modifyGrade
        };

        for (var key in selectAdmin) {
            delete_errors = "";

            if (selectAdmin[key].length === 0 || selectAdmin[key] === undefined) {
                delete_key = key;

                if (key === 'name') {
                    delete_errors = "[관리자명]이 없습니다.";
                } else if (key === 'email') {
                    delete_errors = "[아이디]가 없습니다.";
                } else if (key === 'password') {
                    delete_errors = "[비밀번호]가 없습니다.";
                } else if (key === 'passwordConfirm') {
                    delete_errors = "[비밀번호 확인]이 없습니다."
                } else if (key === 'grade') {
                    delete_errors = "[관리등급]을 선택해주세요.";
                }
            }

            if (delete_errors.length > 1)
                break;
        }

        if (delete_errors.length > 1) {
            alert(delete_errors);

            if (delete_key === 'name') {
                focusRefModifyName.current.focus();
            } else if (delete_key === 'email') {
                //
            } else if (delete_key === 'password') {
                focusRefModifyPassword.current.focus();
            } else if (delete_key === 'passwordConfirm') {
                focusRefModifyPasswordConfirm.current.focus();
            }

            return;
        }

        const passwordRegex =
        // /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+])(?!.*[^a-zA-z0-9$`~!@$!%*#^?&\\(\\)\-_=+]).{8,20}$/;
        /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,25}$/;
        if (!passwordRegex.test(modifyPassword)) {
            delete_errors = "영문, 숫자, 특수문자 포함 8자 이상 입력해주세요.";
            alert(delete_errors);
            focusRefModifyPassword.current.focus();
            return;
        }

        if (modifyPassword !== modifyPasswordConfirm) {
            delete_errors = "비밀번호가 틀려요. 다시 확인해주세요.";
            alert(delete_errors);
            setInputsModify({
                ...inputsModify,
                modifyPasswordConfirm: ""
            });
            focusRefModifyPasswordConfirm.current.focus();
            return;
        }
  
        let body = {
            email: modifyEmail,
            password: modifyPassword,
            name: modifyName,
            grade: modifyGrade
        }
        // console.log(body);

        let delete_msg = "";

        dispatch(deleteAdmin(body))
        .then(response => {
            console.log(response);

            if (response.payload.deleteSuccess) {
                delete_msg = "[" + body.email + " (" + body.name + ")] 관리자 삭제 되었습니다.";
                alert(delete_msg);
                window.location.replace('/AdminSetting');
            } else {
                alert(response.payload.message);
            }
        }).catch((err) => console.log(err));
    };

    // End - 관리자 정보수정  Modify Administrator Information [삭제]
    // -->

    // <!--
    // Start - 관리자 추가  Add Administrator
    const focusRefRegisterName = useRef();
    const focusRefRegisterEmail = useRef();
    const focusRefRegisterPassword = useRef();
    const focusRefRegisterPasswordConfirm = useRef();

    const [inputsRegister, setInputsRegister] = useState({
        registerName: "",
        registerEmail: "",
        registerPassword: "",
        registerPasswordConfirm: "",
        registerGrade: "1"
    });

    const { registerName, registerEmail, registerPassword, registerPasswordConfirm, registerGrade } = inputsRegister;

    const handleChangeRegister = (e) => {
        const { value, name } = e.target;
        setInputsRegister({
            ...inputsRegister,
            [name]: value
        });
    };

    const handleSubmitRegister = (e) => {
        e.preventDefault();
        
        let register_key = "";
        let register_errors = "";

        const newAdmin = {
            name: registerName,
            email: registerEmail,
            password: registerPassword,
            passwordConfirm: registerPasswordConfirm,
            grade: registerGrade
        };

        for (var key in newAdmin) {
            register_errors = "";

            if (newAdmin[key].length === 0 || newAdmin[key] === undefined) {
                register_key = key;

                if (key === 'name') {
                    register_errors = "[관리자명]이 없습니다.";
                } else if (key === 'email') {
                    register_errors = "[아이디]가 없습니다.";
                } else if (key === 'password') {
                    register_errors = "[비밀번호]가 없습니다.";
                } else if (key === 'passwordConfirm') {
                    register_errors = "[비밀번호 확인]이 없습니다."
                } else if (key === 'grade') {
                    register_errors = "[관리등급]을 선택해주세요.";
                }
            }

            if (register_errors.length > 1)
                break;
        }

        if (register_errors.length > 1) {
            alert(register_errors);

            if (register_key === 'name') {
                focusRefRegisterName.current.focus();
            } else if (register_key === 'email') {
                focusRefRegisterEmail.current.focus();
            } else if (register_key === 'password') {
                focusRefRegisterPassword.current.focus();
            } else if (register_key === 'passwordConfirm') {
                focusRefRegisterPasswordConfirm.current.focus();
            }

            return;
        }

        if (registerName.length < 2 || registerName.length > 30) {
            register_errors = "2글자 이상 30글자 미만으로 입력해주세요.";
            alert(register_errors);
            focusRefRegisterName.current.focus();
            return;
        }

        const emailRegex =
        // /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
        /([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if (!emailRegex.test(registerEmail)) {
            register_errors = "올바른 이메일을 입력해주세요.";
            alert(register_errors);
            focusRefRegisterEmail.current.focus();
            return;
        }
  
        const passwordRegex =
        // /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+])(?!.*[^a-zA-z0-9$`~!@$!%*#^?&\\(\\)\-_=+]).{8,20}$/;
        /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,25}$/;
        if (!passwordRegex.test(registerPassword)) {
            register_errors = "영문, 숫자, 특수문자 포함 8자 이상 입력해주세요.";
            alert(register_errors);
            focusRefRegisterPassword.current.focus();
            return;
        }

        if (registerPassword !== registerPasswordConfirm) {
            register_errors = "비밀번호가 틀려요. 다시 확인해주세요.";
            alert(register_errors);
            setInputsRegister({
                ...inputsRegister,
                registerPasswordConfirm: ""
            });
            focusRefRegisterPasswordConfirm.current.focus();
            return;
        }
  
        let body = {
            email: registerEmail,
            password: registerPassword,
            name: registerName,
            grade: registerGrade
        }
        // console.log(body);

        let register_msg = "";

        dispatch(findAdmin(body))
        .then(response => {
            console.log(response.payload);

            if (response.payload.findSuccess) {
                let adminInfo = response.payload.adminInfo;
                
                if (adminInfo.accountActive === "Y") {
                    register_msg = "[" + body.email + "] 등록된 관리자가 있습니다.";
                    alert(register_msg);
                } else {
                    dispatch(updateAdmin(body))
                    .then(response => {
                        if (response.payload.updateSuccess) {
                            register_msg = "[" + body.email + " (" + body.name + ")] 관리자 추가 되었습니다.";
                            alert(register_msg);
                            window.location.replace('/AdminSetting');
                        } else {
                            alert(response.payload.message);
                        }
                    }).catch((err) => console.log(err));
                }
            } else {
                dispatch(registerAdmin(body))
                .then(response => {
                    // console.log(response);
        
                    if (response.payload.registerSuccess) {
                        register_msg = "[" + body.email + " (" + body.name + ")] 관리자 추가 되었습니다.";
                        alert(register_msg);
                        window.location.replace('/AdminSetting');
                    } else {
                        alert(response.payload.message);
                    }
                }).catch((err) => console.log(err));
            }
        }).catch((err) => console.log(err));
    };

    const [showRegisterPassword, setShowRegisterPassword] = useState(false);
    const handleClickShowRegisterPassword = () => setShowRegisterPassword((show) => !show);
    const handleMouseDownRegisterPassword = (event) => {
      event.preventDefault();
    }

    const [showRegisterPasswordConfirm, setShowRegisterPasswordConfirm] = useState(false);
    const handleClickShowRegisterPasswordConfirm = () => setShowRegisterPasswordConfirm((show) => !show);
    const handleMouseDownRegisterPasswordConfirm = (event) => {
      event.preventDefault();
    }
    // End - 관리자 추가  Add Administrator
    // -->

    return (
        <div className="container">
            <div className="header-wrap">
                <h1>관리자 설정</h1>
                <div className="info-wrap">
                    <div className="info-id">
                        <span>{adminAccount.name}</span>
                        <button className="logout-btn" onClick={onLogoutHandler}>로그아웃</button>
                    </div>
                    <div className="info-email">
                        {adminAccount.email}
                    </div>
                </div>
            </div>

            <div className="body-wrap-setting">
                <div className="setting-grop-1">
                    <div className="setting-layout-1">
                        <div className="setting-layout-header">
                            <h3>관리자 리스트</h3> <span>Administrator List</span>
                        </div>
                        <div className="settingLayoutBody2">
                            <ul className="realtimeTableTh">
                                <li>선택</li>
                                <li>관리자명</li>
                                <li>아이디</li>
                                <li>관리등급</li>
                            </ul>
                        {
                            adminListInfo.map((admin, index) => (
                            <ul className="realtimeTableTd" key={admin._id}>
                                <li>
                                {/*
                                    <Checkbox
                                        {...label}
                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                                    />
                                */}
                                    <FormControl>
                                        <RadioGroup
                                            id="listSelect"
                                            name="listSelect"
                                            value={selectedIndex}
                                            onChange={handleChangeListSelect}
                                            row
                                            aria-labelledby="list-row-radio-buttons-group-label"
                                        >
                                            <FormControlLabel value={index} control={<Radio />} label={index + 1} />
                                        </RadioGroup>
                                    </FormControl>
                                </li>
                                <li>{admin.name}</li>
                                <li className="idText">{admin.email}</li>
                                <li>{admin.grade === "0" ? "최고관리자" : "일반관리자"}</li>
                            </ul>
                            ))
                        }
                        </div>
                    </div>
                    <div className="setting-layout-2">
                        <div className="setting-layout-2_1">
                            <div className="setting-layout-header">
                                <h3>관리자 정보수정</h3> <span>Modify Administrator Information</span>
                            </div>
                            <div className="settingLayoutBody1">
                                <div className="textInputList">
                                    관리자명
                                    <input
                                        id="modifyName"
                                        name="modifyName"
                                        value={modifyName}
                                        onChange={handleChangeModify}
                                        required
                                        ref={focusRefModifyName}
                                        className="textInput3"
                                        type="text"
                                        placeholder="관리자명을 입력하세요" />
                                </div>
                                <div className="textInputList">
                                    아이디
                                    <input
                                        id="modifyEmail"
                                        name="modifyEmail"
                                        value={modifyEmail}
                                        required
                                        className="textInput2"
                                        disabled="disabled"
                                        type="text" />
                                </div>
                                <div className="textInputList">
                                    비밀번호
                                    <FormControl sx={{ width: '80%' }} variant="outlined">
                                        <OutlinedInput
                                            style={{ border: '1px', borderRadius: '8px', marginLeft: '18px', padding: '12px 12px 12px 2px',  height: '46px' }}
                                            id="modifyPassword"
                                            name="modifyPassword"
                                            value={modifyPassword}
                                            onChange={handleChangeModify}
                                            inputRef={focusRefModifyPassword}
                                            type={showModifyPassword ? 'text' : 'password'}
                                            placeholder="비밀번호를 입력해주세요"
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        arial-label="toggle password visibility"
                                                        onClick={handleClickShowModifyPassword}
                                                        onMouseDown={handleMouseDownModifyPassword}
                                                        edge="end"
                                                    >
                                                        {showModifyPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                    </FormControl>
                                </div>
                                <div className="textInputList">
                                    비밀번호 확인
                                    <FormControl sx={{ width: '80%' }} variant="outlined">
                                        <OutlinedInput
                                            style={{ border: '1px', borderRadius: '8px', marginLeft: '18px', padding: '12px 12px 12px 2px',  height: '46px' }}
                                            id="modifyPasswordConfirm"
                                            name="modifyPasswordConfirm"
                                            value={modifyPasswordConfirm}
                                            onChange={handleChangeModify}
                                            inputRef={focusRefModifyPasswordConfirm}
                                            type={showModifyPasswordConfirm ? 'text' : 'password'}
                                            placeholder="비밀번호를 한번 더 입력해주세요"
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        arial-label="toggle password visibility"
                                                        onClick={handleClickShowModifyPasswordConfirm}
                                                        onMouseDown={handleMouseDownModifyPasswordConfirm}
                                                        edge="end"
                                                    >
                                                        {showModifyPasswordConfirm ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                    </FormControl>
                                </div>
                                <div className="RadioList">
                                    관리등급
                                    <div className="Radio">
                                        <FormControl>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                id="modifyGrade"
                                                name="modifyGrade"
                                                value={modifyGrade}
                                                onChange={handleChangeModify}
                                            >
                                                <FormControlLabel value="1" control={<Radio />} label="일반관리자" />
                                                <FormControlLabel value="0" control={<Radio />} label="최고관리자" />
                                            </RadioGroup>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="AdminSettingBtn">
                                    <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '6px 64px', border: 'none', color:'white'}}
                                            onClick={handleSubmitModify}
                                            variant="outlined">
                                            수 정
                                    </Button>
                                    <Button style={{backgroundColor: '#ffffff', borderRadius:'8px', padding: '6px 32px', marginLeft: '8px', color:'red', borderColor: 'red'}}
                                            onClick={handleSubmitDelete}
                                            variant="outlined">
                                            삭 제
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="setting-layout-2_2">
                            <div className="setting-layout-header">
                                <h3>관리자 추가</h3> <span>Add Administrator</span>
                            </div>
                            <div className="settingLayoutBody1">
                                <div className="textInputList">
                                    관리자명
                                    <input
                                        id="registerName"
                                        name="registerName"
                                        value={registerName}
                                        onChange={handleChangeRegister}
                                        required
                                        ref={focusRefRegisterName}
                                        className="textInput4"
                                        type="text"
                                        placeholder="관리자명을 입력하세요" />
                                </div>
                                <div className="textInputList">
                                    아이디
                                    <input
                                        id="registerEmail"
                                        name="registerEmail"
                                        value={registerEmail}
                                        onChange={handleChangeRegister}
                                        required
                                        ref={focusRefRegisterEmail}
                                        className="textInput4"
                                        type="text" placeholder="아이디를 입력하세요" />
                                </div>
                                <div className="textInputList">
                                    비밀번호
                                    <FormControl sx={{ width: '80%' }} variant="outlined">
                                        <OutlinedInput
                                            style={{ border: '1px', borderRadius: '8px', marginLeft: '18px', padding: '12px 12px 12px 2px',  height: '46px' }}
                                            id="registerPassword"
                                            name="registerPassword"
                                            value={registerPassword}
                                            onChange={handleChangeRegister}
                                            inputRef={focusRefRegisterPassword}
                                            type={showRegisterPassword ? 'text' : 'password'}
                                            placeholder="비밀번호를 입력해주세요"
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        arial-label="toggle password visibility"
                                                        onClick={handleClickShowRegisterPassword}
                                                        onMouseDown={handleMouseDownRegisterPassword}
                                                        edge="end"
                                                    >
                                                        {showRegisterPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                    </FormControl>
                                </div>
                                <div className="textInputList">
                                    비밀번호 확인
                                    <FormControl sx={{ width: '80%' }} variant="outlined">
                                        <OutlinedInput
                                            style={{ border: '1px', borderRadius: '8px', marginLeft: '18px', padding: '12px 12px 12px 2px',  height: '46px' }}
                                            id="registerPasswordConfirm"
                                            name="registerPasswordConfirm"
                                            value={registerPasswordConfirm}
                                            onChange={handleChangeRegister}
                                            inputRef={focusRefRegisterPasswordConfirm}
                                            type={showRegisterPasswordConfirm ? 'text' : 'password'}
                                            placeholder="비밀번호를 한번 더 입력해주세요"
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        arial-label="toggle password visibility"
                                                        onClick={handleClickShowRegisterPasswordConfirm}
                                                        onMouseDown={handleMouseDownRegisterPasswordConfirm}
                                                        edge="end"
                                                    >
                                                        {showRegisterPasswordConfirm ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                    </FormControl>
                                </div>
                                <div className="RadioList">
                                    관리등급
                                    <div className="Radio">
                                        <FormControl>
                                            <RadioGroup
                                                id="registerGrade"
                                                name="registerGrade"
                                                defaultValue="1"
                                                value={registerGrade}
                                                onChange={handleChangeRegister}
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                            >
                                                <FormControlLabel value="1" control={<Radio />} label="일반관리자" />
                                                <FormControlLabel value="0" control={<Radio />} label="최고관리자" />
                                            </RadioGroup>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="AdminSettingBtn">
                                    <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '6px 64px', border: 'none', color:'white'}}
                                            onClick={handleSubmitRegister}
                                            variant="outlined">
                                            추 가
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminSetting;
